import { useElements, useStripe } from "@stripe/react-stripe-js";

import { useToast } from "@chakra-ui/react";
import { useState } from "react";

export const useSetupPaymentMethod: ({ onClose }: { onClose: () => void }) => {
  handleStripePaymentMethodSubmit: (
    event: React.FormEvent<HTMLDivElement>
  ) => void;
  stripePaymentMethodSubmitLoading: boolean;
  stripeErrorMessage: string | undefined;
} = ({ onClose }) => {
  const stripe = useStripe();
  const elements = useElements();
  const toast = useToast();

  const [stripeErrorMessage, setStripeErrorMessage] = useState<
    string | undefined
  >();
  const [
    stripePaymentMethodSubmitLoading,
    setStripePaymentMethodSubmitLoading,
  ] = useState<boolean>(false);

  const handleStripePaymentMethodSubmit = async (
    event: React.FormEvent<HTMLDivElement>
  ) => {
    event.preventDefault();
    setStripePaymentMethodSubmitLoading(true);

    if (!stripe || !elements) {
      return null;
    }

    await stripe
      .confirmSetup({
        elements,
        redirect: "if_required",
      })
      .then(({ error, setupIntent }) => {
        if (error) {
          setStripeErrorMessage(error.message);
        }

        if (!setupIntent || !setupIntent.client_secret) {
          console.error("No setup intent client secret found");
          setStripeErrorMessage("No se ha podido crear el método de pago");
          return;
        }

        stripe
          .retrieveSetupIntent(setupIntent.client_secret)
          .then(({ setupIntent }) => {
            switch (setupIntent?.status) {
              case "succeeded":
                toast({
                  title: "Tarjeta añadida",
                  description: "¡Enhorabuena! Se ha guardado el método de pago",
                  status: "success",
                  duration: 9000,
                  isClosable: true,
                });

                onClose();

                break;

              case "processing":
                toast({
                  title: "En proceso...",
                  description: "Se están procesando los datos introducidos",
                  status: "loading",
                  duration: 9000,
                  isClosable: true,
                });

                break;

              default:
                toast({
                  title: "Error",
                  description:
                    "Ha ocurrido un error. Por favor inténtalo de nuevo o prueba con otra tarjeta",
                  status: "error",
                  duration: 9000,
                  isClosable: true,
                });

                break;
            }
          });
      })
      .finally(() => {
        setStripePaymentMethodSubmitLoading(false);
      });
  };

  return {
    handleStripePaymentMethodSubmit,
    stripePaymentMethodSubmitLoading,
    stripeErrorMessage,
  };
};
